import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "webinar_card_icon_record",
  "use": "webinar_card_icon_record-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"webinar_card_icon_record\"><g fill=\"#1FC762\"><path d=\"M10 4c-3.312 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6Zm0 10.8A4.799 4.799 0 0 1 5.2 10c0-2.652 2.148-4.8 4.8-4.8 2.652 0 4.8 2.148 4.8 4.8 0 2.652-2.148 4.8-4.8 4.8Z\" /><path d=\"M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol